import { makeActionCreator } from '../../config/store/utils'
import { createBuyingModalities } from '../../services/comparatorCharts'
import Unique, { inverse } from '../../modules/utils/arrays'
import theme from '../../config/styles/theme'

export const COMPARATORMODALITIES = 'COMPARATORMODALITIES'
export const COMPARATORMODALITIES_SUCCESS = 'COMPARATORMODALITIES_SUCCESS'
export const COMPARATORMODALITIES_ERROR = 'COMPARATORMODALITIES_ERROR'
export const onComparatorModalities = makeActionCreator(COMPARATORMODALITIES)
export const onComparatorModalitiesSuccess = makeActionCreator(COMPARATORMODALITIES_SUCCESS, 'payload')
export const onComparatorModalitiesError = makeActionCreator(COMPARATORMODALITIES_ERROR, 'payload')
export const onComparatorModalitiesThunk =
  ({ year, idEntity }, type, firstName, secondName) =>
  async dispatch => {
    dispatch(onComparatorModalities())

    try {
      const response = await createBuyingModalities({ year, idEntity })

      if (response.data.success !== 'OK') {
        return dispatch(onComparatorModalitiesError(response.data.errores))
      }

      const firstEntity = response.data.payload[0].data1
      const secondEntity = response.data.payload[0].data2
      // Categories
      const firstCategories = firstEntity.map(category => category.name)
      const secondCategories = secondEntity.map(category => category.name)
      const allCategories = Unique(firstCategories.concat(secondCategories))
      const ObjCategories = inverse(Object.assign({}, allCategories))
      const sortedFirstEntity = firstEntity.sort((a, b) => ObjCategories[a.name] - ObjCategories[b.name])
      const sortedSecondEntity = secondEntity.sort((a, b) => ObjCategories[a.name] - ObjCategories[b.name])

      allCategories.map((category, index) =>
        !sortedFirstEntity.some(item => item.name === category)
          ? sortedFirstEntity.splice(index, 0, { entityName: firstName, name: category, amount: 0, orders: 0 })
          : null
      )

      allCategories.map((category, index) =>
        !sortedSecondEntity.some(item => item.name === category)
          ? sortedSecondEntity.splice(index, 0, { entityName: secondName, name: category, amount: 0, orders: 0 })
          : null
      )

      // Amounts
      const firstAmountData = {
        name: firstName,
        data: sortedFirstEntity.map(item => item.amount),
        color: theme.palette.charts.navyBlue
      }
      const secondAmountData = {
        name: secondName,
        data: sortedSecondEntity.map(item => item.amount),
        color: theme.palette.charts.darkRed
      }
      // Orders
      const firstOrdersData = {
        name: firstName,
        data: sortedFirstEntity.map(item => item.orders),
        color: theme.palette.charts.navyBlue
      }
      const secondOrdersData = {
        name: secondName,
        data: sortedSecondEntity.map(item => item.orders),
        color: theme.palette.charts.darkRed
      }
      // Percentages
      const firstPercentagesData = {
        name: firstName,
        data: sortedFirstEntity.map(item => item.percentage),
        color: theme.palette.charts.navyBlue
      }
      const secondPercentagesData = {
        name: secondName,
        data: sortedSecondEntity.map(item => item.percentage),
        color: theme.palette.charts.darkRed
      }
      // CSV
      const firstCSV = sortedFirstEntity.map(entity => [
        entity.entityName,
        year,
        entity.name,
        entity.orders,
        entity.amount,
        entity.percentage
      ])
      const secondCSV = sortedSecondEntity.map(entity => [
        entity.entityName,
        year,
        entity.name,
        entity.orders,
        entity.amount,
        entity.percentage
      ])
      const types = {
        amount: [firstAmountData, secondAmountData],
        oc: [firstOrdersData, secondOrdersData],
        percentage: [firstPercentagesData, secondPercentagesData]
      }
      const payload = {
        categories: allCategories,
        chart: types[type],
        csvStructure: [
          [
            'Organismo comprador',
            'Año',
            'Mecanismo de compra',
            'N° de órdenes de compra',
            'Monto total transado (CLP)',
            'Monto porcentual'
          ],
          ...firstCSV,
          ...secondCSV
        ]
      }

      return dispatch(onComparatorModalitiesSuccess(payload))
    } catch (error) {
      return dispatch(onComparatorModalitiesError(error))
    }
  }
